import { applyEach, pattern, schema, SchemaPathTree, validate } from '@angular/forms/signals';
import { VALIDATION_PATTERNS } from '@dss-libs/shared/type/common-types';
import { IInviteMembersFormModel } from '../../models/portal-core-features/invite-members.model';

export const inviteMembersSchema = schema((path: SchemaPathTree<IInviteMembersFormModel>) => {
  applyEach(path.members, (item) => {
    pattern(item.email, VALIDATION_PATTERNS.email, {
      message: 'VALIDATION_MESSAGES.EMAIL_INVALID',
      when: ({ value }) => value() !== '',
    });
    validate(item.email, ({ value, valueOf }) => {
      const email = value().trim();
      if (!email) return undefined;
      const allMembers = valueOf(path.members);
      const count = allMembers.filter((member) => member.email.trim() === email).length;
      return count > 1 ? { kind: 'noDuplicate', message: 'VALIDATION_MESSAGES.DUPLICATE_EMAIL' } : undefined;
    });
  });
});
